import React from 'react';
import { Stack, Strong } from '@ovotech/element-v5';
import { CodeBox } from '@/src/components/payg/CodeBox';

type Props = {
  error: string;
};

export const ErrorCode = ({ error }: Props) => (
  <Stack spaceBetween={2}>
    <Strong>Error code</Strong>
    <CodeBox code={error} accessibilityLabel="Error code" />
  </Stack>
);
